import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'gp-chart-loading-animation',
  templateUrl: './chart-loading-animation.component.html',
  styleUrls: ['./chart-loading-animation.component.scss']
})
export class ChartLoadingAnimationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
